import { useState } from 'react';

import { useFormContext } from 'react-hook-form';
import RefundForm from '../models/RefundForm';
import RefundLineItem from '../models/RefundLineItem';
import type RefundProductDto from '../models/RefundProductDto';

type RefundLineItemCache = Map<RefundLineItem['itemNo'], RefundLineItem>;

const mapRefundProductDtoIntoRefundLineItem = (
    refundProduct: RefundProductDto
): RefundLineItem => ({
    itemNo: refundProduct.itemNo,
    description: refundProduct.description,
    quantity: 1,
    shippedQtyNotReturned: refundProduct.shippedQtyNotReturned,
    unitOfMeasureCode: refundProduct.unitOfMeasureCode,
    SourceNo: refundProduct.SourceNo,
    documentType: refundProduct.documentType,
    documentNo: refundProduct.documentNo,
    image: refundProduct.image,
});

const useRefundLineItems = () => {
    const form = useFormContext<RefundForm>();

    const [cache, setCache] = useState<RefundLineItemCache>(() => {
        const items = form.getValues('products');

        const map = new Map();

        items?.forEach((item: RefundLineItem): void => {
            map.set(item.itemNo, item);
        });

        return map;
    });

    const handleAdd = (refundProduct: RefundProductDto) => {
        const itemNo = refundProduct.itemNo;
        const copy = new Map(cache);
        copy.set(itemNo, mapRefundProductDtoIntoRefundLineItem(refundProduct));
        setCache(copy);
    };

    const handleRemove = (itemNo: RefundLineItem['itemNo']) => {
        const copy = new Map(cache);
        copy.delete(itemNo);
        setCache(copy);
    };

    return {
        remove: handleRemove,
        add: handleAdd,
        cache,
    };
};

export default useRefundLineItems;
